import cx from 'classnames'
import React from 'react'

export function OrderedList (props) {
  return (
    <ol
      {...props.attributes}
      className={cx(props.attributes.className, 'list-decimal')}
      style={props.style}
    >
      {props.children}
    </ol>
  )
}
